import { sensitiveStorage } from "../core/services/SensitiveStorage";
import ClipLoader  from 'vue-spinner/src/ClipLoader.vue';
import { mapState, mapGetters } from "vuex";

export default {
    data() {
        return {
            user_name: {},
            flgCardSts:{},
            color:"#ff8533",
            // Default loading state
            loading:false,
            timeout: null,
            modalShow: false,    //  modalCalendar
            timeables:[],
            timeableInfo: Object,
            cancelFee : 0,
            loadingCounter: 0,
            japaneseHolidays:[],
        };
    },
    components: {
        'ClipLoader': ClipLoader 
    },
    computed: {
        // SHINANO(splus: #64061 No.4) 2020-07-10 add start
        ...mapState([
            'isNotFound'
        ]),
        // SHINANO(splus: #64061 No.4) 2020-07-10 add end
        getHomePageUrl() {
            if (this.$store.state.lang !== null && this.$store.state.lang !== '') {
                return { path: 'home/index', name: 'home-index', params: { lang: this.$store.state.lang } };
            } else {
                return { path: 'home/index', name: 'home-index' };
            }
        },
        getParamLang() {
            if (this.$store.state.lang !== null && this.$store.state.lang !== '') {
                return { lang: this.$store.state.lang };
            } else {
                return {};
            }
        },
        isDisabled: function(){
            if(this.disable == true && this.quantity > 0){
                return false;
            }
            return true;
        },
        startStation() {
            return {
                name: this.timeables[0].stationName,
                departureTime: this.timeables[0].departureTime,
            }
        },
        endStation() {
            return {
                name: this.timeables[this.timeables.length - 1].stationName,
                arrivalTime: this.timeables[this.timeables.length - 1].arrivalTime,
            }
        },
        numberSeatBooking() {
            return this.$store.state.numberSeatBooking;
        },
        ...mapState(['flgLogin']),
        ...mapGetters([
            'isJaLanguage'
        ])
    },
    /**
     * Author: BinhNT1
     * Action: Run before page load
     */
    created() {
        this.getCancelFee();
        this.getJapaneseHolidays();
        //use to check status of navigation bar

        if (sensitiveStorage.getUsername()) {
            this.user_name = sensitiveStorage.getUsername();
            this.$store.commit('setFlgLogin', true);
        } else {
            this.$store.commit('setFlgLogin', false);
        }

        //Common use to call when user login
        this.$bus.$on("logged", () => {
            this.$store.commit('setFlgLogin', true);
            this.user_name = sensitiveStorage.getUsername();
            
        });

        // Common use to call when user logout
        this.$bus.$on("logout", ($pagePushName) => {
            this.loadingCounter = 0;
            this.loading = false;
            this.logout($pagePushName);
        });

        // SHINANO(splus: #64061 No.1) 2020-07-06 add start
        this.$bus.$on("nonUserTokenReset", ($pagePushName) => {
            this.loadingCounter = 0;
            this.loading = false;
            this.$store.commit('setJwt', '');
            this.$router.push({ 
                name: $pagePushName,
                params: { lang: this.$i18n.locale === 'ja' ? null : this.$i18n.locale }
            });
        });
        // SHINANO(splus: #64061 No.1) 2020-07-06 add end

        //Update Status User
        this.$bus.$on("updateStatusUser", () => {
            this.$store.commit('setFlgLogin', false);
        });

         // Common use to edit user info
        this.$bus.$on("user_updated", () => {
            this.user_name = sensitiveStorage.getUsername();
        });

        // Loading state. flase : is hiden - true : is show
        this.$bus.$on("update_loading_state", (loading) => {
            const DELAY_LOADING_TIME = 0; // milliseconds

            if (loading) {
                this.loadingCounter++;
                setTimeout(() => {
                  if (this.loadingCounter > 0) {
                    this.loading = true;
                  }
                }, DELAY_LOADING_TIME);
              } else {
                if (this.loadingCounter > 0) this.loadingCounter--;
                setTimeout(() => {
                  if (this.loadingCounter <= 0) {
                    this.loading = false;
                  }
                }, 200);
            }
        });

        this.$bus.$on("confirmSeatSelection", () => {
            if (this.flgLogin) {
                this.$router.push({ name: "payment" });
            } else {
                this.$router.push({ name: "paymentnonuser" });
            }
        });

        this.$bus.$on("showModalCalendar", async ($timeablesData) => {
            // Show loading.
            this.$bus.$emit("update_loading_state", true);

            this.timeableInfo.trainName = $timeablesData.trainName;
            this.timeableInfo.departureTime = $timeablesData.departureTime;
            this.timeableInfo.arrivalTime = $timeablesData.arrivalTime;

            // Call api get Train timeable.
            let response = await this.$httpClient.sendPost('select-time/train-timeable', $timeablesData);

            // Hide loading.
            this.$bus.$emit("update_loading_state", false);

            this.timeables = response.data.data;
            this.modalShow = true;   //  modalCalendar
        });
        this.$bus.$on("cardSts_updated",()=>{
            if(sessionStorage.getItem('card_status') === '1'){
                this.flgCardSts =  true;
            }else{
                this.flgCardSts =  false;
            }
        });

        // Init number ticket on header
        this.$store.commit('setNumberTicketFromStorage');

        // GMO env init
        this.gmoEnvInit();
    },
    mounted() {
        document.title = this.$t('app.page.title');
    },
    methods: {
        /**
         * Author: BinhNT1
         * Link: ログアウト
         * Action: logout and redirect to 「トップ画面」.(US_01-01)
         */
        async logout($pagePushName) {
            await this.$httpClient.sendPost('/logout');    
            this.$store.commit('setFlgLogin', false);
            sensitiveStorage.removeUsername();
            sensitiveStorage.removeUserId();
            sessionStorage.removeItem('card_status');
            if($pagePushName != null) {
                this.$router.push({ 
                    name: $pagePushName,
                    params: { lang: this.$i18n.locale === 'ja' ? null : this.$i18n.locale }
                });
            }
        },
        /**
         * Author: BinhNT1
         * Action: Check if have any user logined or not
         */
        checkLogin() {
            if (sensitiveStorage.getUsername() != null) {
                this.$store.commit('setFlgLogin', true);
                this.checkCardSts();
                this.user_name = sensitiveStorage.getUsername();
            } else {
                this.$store.commit('setFlgLogin', false);
            }
        },
        checkCardSts(){
            if(sessionStorage.getItem('card_status') == 1){
                this.flgCardSts =  true;
            }else{
                this.flgCardSts =  false;
            }
        },
        async gmoEnvInit() {
            const res = await this.$httpClient.sendGet('gmo/env');
            this.$store.commit('setGmoENV', res.data.data)
        },
        async getCancelFee(){
            let response = await this.$httpClient.sendGet('/purchase-history/cancel-fee');
            if (response.data.data !== null) {
                this.cancelFee = response.data.data.cancelFee;
            }
            console.log('cancel fee :', this.cancelFee);
            this.$store.commit('setCancelFree', this.cancelFee);
        },
        async getJapaneseHolidays(){
            let response = await this.$httpClient.sendGet('/purchase-history/get-japanese-holidays');
            if (response.data.data !== null) {
                this.japaneseHolidays = response.data.data;
            }
            this.$store.commit('setJapaneseHolidays', this.japaneseHolidays);
        },
        historyPuchase(arg){
            console.log(arg);
            this.$router.push({
                name : 'purchase-history-index',
                params : {setPageNumber : 'set'}
            });
        },
        async loadPage(language){
            if (sensitiveStorage.getUsername() != null) {
                if (this.flgLogin) {
                    await this.$httpClient.sendPost('/logout');  
                    this.$store.commit('setLanguageWeb', language);
                    this.$store.commit('setFlgLogin', false);
                    sensitiveStorage.removeUsername();
                    sensitiveStorage.removeUserId();
                    sessionStorage.removeItem('card_status'); 
                    this.$router.push({
                        name : 'home-index',
                        params: { lang: language }
                    });  
                }
            }else{
                this.$store.commit('setLanguageWeb', language);
                this.$router.push({
                    name : 'home-index',
                    params: { lang: language }
                });
            }
            // if(this.$route.name == "select_time_oneway"){
            //     this.$bus.$emit("loadListTrainOneWay");
            // }else if(this.$route.name == "select_time_roundtrip"){
            //     this.$bus.$emit("loadListTrainRoundTrip");
            // }
            // location.reload();
        }
    },
    /**
     * Author: BinhNT1
     * Action: Run when page refresh
     */
    beforeMount() {
        this.checkLogin();
    }
};
